export class UserDefinedPage {
  tabId: number = -1;
  userTabId: string = '';
  parentTabId: number = -1;
  tabName: string = '';
  index: number = -1;
  visibility: boolean = false;
  editable: boolean = false;
  sharedTab: boolean = false;
  widgets: number[] = [];
}
